import { Transition } from "@headlessui/react";
import {
  IconX,
  IconCircleCheckFilled,
  IconAlertSquareRoundedFilled,
  IconInfoCircleFilled,
  IconExclamationCircleFilled,
} from "@tabler/icons-react";
import useToaster from "./use_toaster";

function Toaster() {
  const { state, close } = useToaster();
  return (
    <>
      {/* Global notification live region, render this permanently at the end of the document */}
      <div
        aria-live="assertive"
        className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
      >
        <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <Transition show={state.show}>
            <div className="pointer-events-auto w-full max-w-sm rounded-lg bg-white shadow-lg outline-1 outline-black/5 transition data-closed:opacity-0 data-enter:transform data-enter:duration-300 data-enter:ease-out data-closed:data-enter:translate-y-2 data-leave:duration-100 data-leave:ease-in data-closed:data-enter:sm:translate-x-2 data-closed:data-enter:sm:translate-y-0 dark:bg-gray-800 dark:-outline-offset-1 dark:outline-white/10">
              <div className="p-4 ">
                <div className="flex items-start">
                  <div className="shrink-0">
                    {state.type === 1 ? ( // INFO
                      <IconInfoCircleFilled
                        aria-hidden="true"
                        className="size-6 text-blue-400"
                      />
                    ) : state.type === 2 ? ( // WARN
                      <IconAlertSquareRoundedFilled
                        aria-hidden="true"
                        className="size-6 text-orange-400"
                      />
                    ) : state.type === 3 ? ( // ERROR
                      <IconExclamationCircleFilled
                        aria-hidden="true"
                        className="size-6 text-red-400"
                      />
                    ) : state.type === 4 ? (
                      <IconCircleCheckFilled // SUCCESS
                        aria-hidden="true"
                        className="size-6 text-green-400"
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p className="text-sm font-medium text-gray-900 dark:text-white">
                      {state.title}
                    </p>
                    <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                      {state.message}
                    </p>
                  </div>
                  <div className="ml-4 flex shrink-0">
                    <button
                      type="button"
                      onClick={close}
                      className="inline-flex rounded-md text-gray-400 hover:text-gray-500 focus:outline-2 focus:outline-offset-2 focus:outline-indigo-600 dark:hover:text-white dark:focus:outline-indigo-500"
                    >
                      <span className="sr-only">Close</span>
                      <IconX aria-hidden="true" className="size-5" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </>
  );
}

export default Toaster;
